import * as React from 'react';
import { SVGProps } from 'react';

const SvgArrowsUpDown = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg width={8} height={8} viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.283 4.835a.625.625 0 0 1 .882-.052L4 6.413l1.835-1.63a.625.625 0 1 1 .83.934l-2.25 2a.625.625 0 0 1-.83 0l-2.25-2a.625.625 0 0 1-.052-.882ZM6.717 3.165a.625.625 0 0 1-.882.052L4 1.587l-1.835 1.63a.625.625 0 1 1-.83-.934l2.25-2a.625.625 0 0 1 .83 0l2.25 2c.258.23.281.624.052.882Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgArrowsUpDown;
